<script setup lang="ts">
import { RefreshCw } from 'lucide-vue-next';

import { Button } from '@/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger
} from '@/components/ui/tooltip';
import { useAppVersionStore } from '@/stores/appVersion';

const props = defineProps<{
    isSidebarOpen?: boolean;
}>();

const appVersion = useAppVersionStore();

const reload = () => window.location.reload();
</script>

<template>
    <div v-if="appVersion.isOutdated" class="app-update">
        <div
            v-if="props.isSidebarOpen"
            class="flex flex-col gap-2 rounded-lg bg-primary20 p-3"
        >
            <div class="flex items-center gap-2">
                <span class="h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                <p class="text-sm font-semibold text-foreground">
                    Update available
                </p>
            </div>
            <p class="text-xs text-muted-foreground">
                Reload to apply. Unsaved changes will be lost.
            </p>
            <Button size="sm" class="w-full" @click="reload">Reload</Button>
        </div>

        <Tooltip v-else>
            <TooltipTrigger as-child>
                <Button
                    variant="ghost"
                    class="w-full px-0 text-foreground"
                    @click="reload"
                >
                    <RefreshCw class="h-5 w-5 shrink-0" />
                </Button>
            </TooltipTrigger>
            <TooltipContent side="right">
                <p>Update available — reload to apply</p>
            </TooltipContent>
        </Tooltip>
    </div>
</template>
